module.exports = __webpack_public_path__ + "static/media/lv2_clean_grid.e2111c5b.jpg";